<style lang="less" scoped>
  @import "../../../style/theme.less";

  h1 {
    font-family: "Kaushan Script", cursive;
    font-weight: 400;
    font-size: 28px;
  }

  .action-button {
    font-family: "Kaushan Script", cursive;
    font-weight: 600;
  }

  .ant-form-item {
    margin-bottom: 12px;
  }
</style>

<template>
  <div>
    <h1>Your Journey Begins!</h1>
    <p>The 100 questions in this {{ constants.report.typeDescriptors[submission.reportType] }} Quiz allow our professionally designed program to develop a unique, personalized report, just for you.<br><br>
    To make this quiz uniquely yours, we need the following information from you:</p>

    <a-form layout="vertical">
      <a-form-item>
        <a-input
          placeholder="Your Name"
          v-model="form.name"
          :disabled="loading"
        />
      </a-form-item>
      <a-form-item>
        <a-row :gutter="[16, 16]">
          <a-col :span="12">
            <a-input-number
              :min="14"
              :max="120"
              placeholder="Your Age"
              style="width: 100%"
              v-model="form.age"
              :disabled="loading"
            />
          </a-col>
          <a-col :span="12">
            <a-select
              placeholder="Your Gender"
              style="width: 100%"
              v-model="form.gender"
              :disabled="loading"
            >
              <a-select-option
                v-for="gender in Object.keys(constants.genders.genders)"
                :key="gender"
                :value="gender"
              >
                {{ constants.genders.genderDescriptors[gender] }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item>
        <a-checkbox v-model="form.tos">
          I have read and agree with the
          <a
            href="https://goddessgift.com/privacy-gdpr-policy/#terms"
            style="text-decoration: underline"
            target="_blank"
          >
            Terms of Service
          </a>
        </a-checkbox>
      </a-form-item>
      <a-form-item>
        <a-button
          class="action-button"
          size="large"
          shape="round"
          type="primary"
          @click="submit"
          :disabled="!form.tos"
          :loading="loading"
        >
          Submit
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import { getErrorMessage } from '../../../lib/utils';

export default {
  name: 'user.start',

  data: () => ({
    form: {
      name: undefined,
      age: undefined,
      gender: undefined,
      tos: false,
    },
  }),

  mounted() {
    if (!this.licenseKey) {
      return this.$router.replace({ name: 'user.landing', });
    }

    return this.listConstants()
      .catch(e => {
        console.log('error', e);
      });
  },

  computed: mapState('user', ['licenseKey', 'loading', 'constants', 'error', 'submission',]),

  methods: {
    ...mapActions('user', ['createSubmission', 'listConstants',]),
    ...mapMutations('user', ['setError',]),

    submit() {
      if (!this.form.name) {
        return this.setError({
          message: 'Please enter your name before continuing',
          show: true,
        });
      } else if (!this.form.age) {
        return this.setError({
          message: 'Please enter your age before continuing',
          show: true,
        });
      } else if (!this.form.gender) {
        return this.setError({
          message: 'Please enter your gender before continuing',
          show: true,
        });
      }

      this.setError({});

      const data = {
        name: this.form.name,
        age: this.form.age,
        gender: this.form.gender,
        licenseKey: this.licenseKey,
      };

      return this.createSubmission(data)
        .then(() => {
          this.$router.push({ name: 'user.questions', });
        })
        .catch(e => {
          this.error = {
            show: true,
            message: getErrorMessage(e),
          };
        });
    },
  },
};
</script>
